<div class="form-check">
    <input
        #input
        attr.data-uit="radio-input-{{ value }}"
        class="form-check-input ca-radio-input"
        [ngClass]="{ checked: checked }"
        type="radio"
        [id]="inputId"
        [checked]="checked"
        [disabled]="disabled"
        [tabIndex]="tabIndex"
        [attr.name]="name"
        [attr.value]="value"
        [required]="required"
        [attr.aria-label]="ariaLabel"
        [attr.aria-labelledby]="ariaLabelledby"
        [attr.aria-describedby]="ariaDescribedby"
        (change)="_onInputChange($event)"
        (click)="_onInputClick($event)"
    />

    <label [attr.for]="inputId" class="form-check-label font-m ms-2" attr.data-uit="radio-input-label-{{ value }}">
        <ng-content></ng-content>
    </label>
</div>
